import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { FieldReviewDetailsColumn } from "./fieldReviewDetailsViewConfig";

export const defaultFieldReviewDetailsView: View = {
    type: ViewType.HISTORY_FIELD_REVIEW,
    columns: [
        { id: FieldReviewDetailsColumn.DATE },
        { id: FieldReviewDetailsColumn.BANK_DESCRIPTION },
        { id: FieldReviewDetailsColumn.FIELD },
        { id: FieldReviewDetailsColumn.FIELD_VALUE },
        { id: FieldReviewDetailsColumn.REVIEWED_BY },
        { id: FieldReviewDetailsColumn.PRIOR_STATUS },
        { id: FieldReviewDetailsColumn.UPDATED_STATUS },
        { id: FieldReviewDetailsColumn.FINANCIAL_ACCOUNT },
        { id: FieldReviewDetailsColumn.AMOUNT },
        { id: FieldReviewDetailsColumn.ENTITY, options: { pin: "right" } },
        { id: FieldReviewDetailsColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        density: ViewDensity.MD,
    },
};
